<template>
    <div>Pivot</div>
</template>

<script>
/* eslint-disable */
import store from "../../store/index";
import axios from 'axios';
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.toolbar.min.js";
import "webdatarocks/webdatarocks.js";
export default {
  name: "DispositionPivot",
  props: {
    afterchartdraw: Function,
    aftergriddraw: Function,
    beforegriddraw: Function,
    beforetoolbarcreated: Function,
    cellclick: Function,
    celldoubleclick: Function,
    componentFolder: String,
    customizeCell: Function,
    customizeContextMenu: Function,
    datachanged: Function,
    dataerror: Function,
    datafilecancelled: Function,
    dataloaded: Function,
    fieldslistclose: Function,
    fieldslistopen: Function,
    filterclose: Function,
    filteropen: Function,
    fullscreen: Function,
    global: Object,
    height: [String, Number],
    loadingdata: Function,
    loadinglocalization: Function,
    loadingolapstructure: Function,
    loadingreportfile: Function,
    localizationerror: Function,
    localizationloaded: Function,
    olapstructureerror: Function,
    olapstructureloaded: Function,
    openingreportfile: Function,
    querycomplete: Function,
    queryerror: Function,
    ready: Function,
    report: [String, Object],
    reportchange: Function,
    reportcomplete: Function,
    reportfilecancelled: Function,
    reportfileerror: Function,
    reportfileloaded: Function,
    runningquery: Function,
    toolbar: Boolean,
    update: Function,
    width: [Number, String],
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      reportdata: [],
    }
  },
  mounted: function() {
    window.addEventListener("studyIdChanged", (event) => {
      this.reportfun();
    });
    this.webdatarocks = new WebDataRocks({
      ...this.$props,
      container: this.$el,
      beforetoolbarcreated: this.customizeToolbar,
      report: {},
      ready:()=>{
         this.reportfun();
      }
    });
  },
  beforeUpdate() {
    return false;
  },
  methods: {
    async reportfun(){
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
          .get(`${this.baseurl}/report/patient/subjectvisitreport?StudyId=${currentstudy}`,
              {
                  headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                  },
              }
          )
          .then((res) => {
              this.reportdata = res.data;
              console.log("cohort report data recieved");
              console.log(res.data);
              let subjectsArray = (res.data && res.data.subjects) ? res.data.subjects : (Array.isArray(res.data) ? res.data : []);
              // console.log(subjectsArray);
              
              
              // Collect all unique visit names across all subjects
              let allVisitNames = [];
              subjectsArray.forEach(subject => {
                if (subject.visits && subject.visits.length > 0) {
                  subject.visits.forEach(visit => {
                    if (visit.visitName && allVisitNames.indexOf(visit.visitName) === -1) {
                      allVisitNames.push(visit.visitName);
                    }
                  });
                }
              });

              // Build one row per subject with visit names as columns
              let processedData = subjectsArray.map(subject => {
                let row = {
                  siteCode: subject.siteCode || "",
                  subjectCode: subject.subjectCode || "",
                  status: subject.status || ""
                };
                // Add each visit name as a column with visitStatus as value
                allVisitNames.forEach(vName => {
                  row[vName] = "";
                });
                if (subject.visits && subject.visits.length > 0) {
                  subject.visits.forEach(visit => {
                    if (visit.visitName) {
                      row[visit.visitName] = visit.visitStatus || "";
                    }
                  });
                }
                return row;
              });

              // Build type metadata row
              let typeRow = {
                siteCode: { type: "string" },
                subjectCode: { type: "string" },
                status: { type: "string" }
              };
              allVisitNames.forEach(vName => {
                typeRow[vName] = { type: "string" };
              });
              processedData.unshift(typeRow);

              // Build slice rows, columns, measures dynamically
              let sliceRows = [
                { "uniqueName": "siteCode" },
                { "uniqueName": "subjectCode" },
                { "uniqueName": "status" }
              ];
              let sliceColumns = [
                { "uniqueName": "siteCode", caption: this.$t('navigations.site code') },
                { "uniqueName": "subjectCode", caption: this.$t('subject code') },
                { "uniqueName": "status", caption: this.$t('navigations.status') }
              ];
              let sliceMeasures = [
                { "uniqueName": "siteCode" },
                { "uniqueName": "subjectCode" },
                { "uniqueName": "status" }
              ];
              allVisitNames.forEach(vName => {
                sliceRows.push({ "uniqueName": vName });
                sliceColumns.push({ "uniqueName": vName, caption: vName });
                sliceMeasures.push({ "uniqueName": vName });
              });

              let setrept = {
                dataSource: {
                  data: processedData,
                },
                "options": {
                  "grid": {
                    "type": "flat",
                    "showGrandTotals": "off"
                  }
                },
                "slice": {
                  "rows": sliceRows,
                  "columns": sliceColumns,
                  "measures": sliceMeasures
                }
              }
              this.webdatarocks.setReport(setrept);
          }).catch((err) => {
             console.log(err);
          });
    },
    customizeToolbar(toolbar) {
        var tabs = toolbar.getTabs();
        toolbar.getTabs = function () {
           delete tabs[0]
           delete tabs[1]
            return tabs;
        }
    }
  }
};
</script>
<style scoped>
@import '~webdatarocks/webdatarocks.min.css';
</style>